<div class="card-inline">
    <h3>Coordinadores</h3>
</div>


<div class="card-inline">
    <button (click)="addCoordinator()" mat-mini-fab>
        <mat-icon>add</mat-icon>
    </button>
</div>



<div *ngFor="let physician of coordinators">
    <mat-divider></mat-divider>
    <div class="margin-top-medium">
        <span>Profesional: </span><span><b>{{  physician.Name }}</b></span>
        <span><button [disabled]="physician.Loading" (click)="removeCoordinator(physician)" mat-icon-button><mat-icon>delete</mat-icon></button></span>
    </div>

</div>

<mat-divider></mat-divider>
<br>
<div class="card-inline">
    <h3>Horas presupuestadas</h3>
</div>
<div class="card-inline">
    <button (click)="addBudgetTime()" mat-mini-fab>
        <mat-icon>add</mat-icon>
    </button>
</div>
<div class="margin-botton-medium margin-top-medium">
    <span>Horas: </span><span *ngIf="budgetTime">{{  budgetTime }}</span>
</div>


<div class="card-inline">
    <h3>Profesionales asignados</h3>
</div>
<div class="card-inline">
    <button (click)="addAt()" mat-mini-fab>
        <mat-icon>add</mat-icon>
    </button>
</div>

<div *ngFor="let physician of physicians">
    <mat-divider></mat-divider>
    <div class="margin-top-medium">
        <span>Profesional: </span><span><b>{{  physician.Physician.Name }}</b></span>
        <span><button [disabled]="physician.Loading" (click)="removeAt(physician)" mat-icon-button><mat-icon>delete</mat-icon></button></span>
    </div>
    <span>Práctica: </span><span><b>{{  physician.PracticeRegion.Name }}</b></span>

</div>